import { memorySizes } from "Libs/utils";
import { colorBands } from "src/organization/pages/project/environment/metrics/constant";

import { findMetricsValue } from "../impact/util";
import { HttpMetricsType } from "../types";

export const groupMetricsByStatus = (httpMetrics: HttpMetricsType[]) => {
  const timestampMap = new Set<string>();
  const statuses = new Set<string>();

  httpMetrics.forEach(d => {
    //collect unique times and statuscode
    const timestamp = d.timestamp;
    const statusCode = `${d["http.response.code"]?.charAt(0)}XX`;
    statuses.add(statusCode);
    timestampMap.add(timestamp);
  });

  const data = Array.from(timestampMap.keys()).map(timestamp => {
    const data = {
      timestamp,
      date: new Date(timestamp),
      "1XX": 0,
      "2XX": 0,
      "3XX": 0,
      "4XX": 0,
      "5XX": 0,
      stats: {}
    };

    // sum all the status count for this timeframe
    statuses.forEach(status => {
      //similar status are status in range of the current status code
      // 1XX, 2XX, 3XX, 4XX, 5XX
      const similarStatus = httpMetrics.filter(
        metrics =>
          metrics.timestamp === timestamp &&
          metrics["http.response.code"]?.startsWith(status.charAt(0))
      );
      const sumStatus = similarStatus.reduce((sum, metrics) => {
        sum += findMetricsValue(metrics, "response.status")?.sum || 0;
        return sum;
      }, 0);

      data[status] = sumStatus;
    });
    return data;
  });

  return { data, statuses: Array.from(statuses.keys()) };
};

type UnitType = (typeof memorySizes)[number];

const formatBytes = (bytes: number, unit: UnitType, decimals: number = 2) => {
  if (!bytes) return `${(0).toFixed(decimals)}B`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = unit
    ? memorySizes.indexOf(unit)
    : Math.floor(Math.log(bytes) / Math.log(k));

  return (
    parseFloat(String(bytes / Math.pow(k, i))).toFixed(dm) + "" + memorySizes[i]
  );
};

export default formatBytes;

export const statusColorBands = {
  "1XX": colorBands[6],
  "2XX": colorBands[0],
  "3XX": colorBands[2],
  "4XX": colorBands[1],
  "5XX": colorBands[9]
} as const;
